import { render, staticRenderFns } from "./stails.vue?vue&type=template&id=2068129f&scoped=true&"
import script from "./stails.vue?vue&type=script&lang=ts&"
export * from "./stails.vue?vue&type=script&lang=ts&"
import style0 from "./stails.vue?vue&type=style&index=0&id=2068129f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068129f",
  null
  
)

export default component.exports